// extracted by mini-css-extract-plugin
module.exports = {"faqhdr":"single-faq_faqhdr__1vQyq","open":"single-faq_open__e2Ir5","faqBody":"single-faq_faqBody__1Ri4C"};